import React, { useState, useMemo } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import { Card, Snackbar, Alert } from "@mui/material";
import HeaderAseguramiento from "./components/HeaderAseguramiento";

const Aseguramiento = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Analizar datos del localStorage para determinar si es admin
  const isAdmin = useMemo(() => {
    try {
      const userData = localStorage.getItem("user");

      if (!userData) {
        return false;
      }

      const parsed = JSON.parse(userData);

      let roleObj = null;
      let roleName = "";
      let roleId = null;

      if (parsed.user?.role) {
        roleObj = parsed.user.role;
      } else if (parsed.role) {
        roleObj = parsed.role;
      } else if (parsed.more?.role) {
        roleObj = parsed.more.role;
      }

      if (roleObj) {
        if (typeof roleObj === "object" && roleObj !== null) {
          roleId = roleObj.id;
          roleName = roleObj.name || "";

          if (roleId === 10) {
            return true;
          }

          if (
            roleName.toLowerCase().includes("admin iserra100") ||
            roleName.toLowerCase().includes("administrador")
          ) {
            return true;
          }
        } else if (typeof roleObj === "string") {
          roleName = roleObj;
          const roleStr = roleName.toLowerCase();
          const username = (parsed.user?.username || parsed.username || "").toLowerCase();

          if (
            roleStr.includes("admin iserra100") ||
            roleStr.includes("administrador") ||
            username === "admin"
          ) {
            return true;
          }
        }
      }

      const username = (parsed.user?.username || parsed.username || "").toLowerCase();
      if (username === "admin") {
        return true;
      }

      return false;
    } catch (error) {
      console.error("❌ Error analizando datos de usuario:", error);
      return false;
    }
  }, []);

  // Obtener rol del usuario actual
  const currentUserRole = useMemo(() => {
    try {
      const userData = localStorage.getItem("user");
      if (!userData) {
        return "No identificado";
      }

      const parsed = JSON.parse(userData);
      let roleObj = null;

      if (parsed.user?.role) {
        roleObj = parsed.user.role;
      } else if (parsed.role) {
        roleObj = parsed.role;
      } else if (parsed.more?.role) {
        roleObj = parsed.more.role;
      }

      if (roleObj) {
        if (typeof roleObj === "object" && roleObj !== null) {
          return roleObj.name || "Rol sin nombre";
        }
        return roleObj;
      }

      return "Usuario";
    } catch (error) {
      console.error("❌ currentUserRole - Error:", error);
      return "Error";
    }
  }, []);

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleRefresh = () => {
    setRefreshFlag((prev) => !prev);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={0} />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={handleCloseSnackbar}
          sx={{
            width: "100%",
            backgroundColor: snackbar.severity === "success" ? "#f0fff4" : "#fff5f5",
            color: snackbar.severity === "success" ? "#276749" : "#c53030",
            border: snackbar.severity === "success" ? "1px solid #c6f6d5" : "1px solid #fed7d7",
            boxShadow: 2,
            "& .MuiAlert-icon": {
              color: snackbar.severity === "success" ? "#276749" : "#c53030",
            },
          }}
        >
          <MDTypography variant="body1" fontWeight="bold">
            {snackbar.severity === "success" ? "¡Éxito!" : "Error"}
          </MDTypography>
          <MDTypography variant="body2">{snackbar.message}</MDTypography>
        </Alert>
      </Snackbar>

      <HeaderAseguramiento
        refreshFlag={refreshFlag}
        currentUserRole={currentUserRole}
        isAdmin={isAdmin}
        onError={(error) => {
          if (error) {
            setSnackbar({
              open: true,
              message: error,
              severity: "error",
            });
          }
        }}
      />
    </DashboardLayout>
  );
};

export default Aseguramiento;
